import "./Pagination.css";

const Pagination = ({ pageCount, currentPage, onPageChange }) => {
  const handlePageClick = (index) => {
    onPageChange(index);
  };

  const renderPageButtons = () => {
    const buttons = [];
    const maxButtonsToShow = 5; // maximalni zobrazovany pocet tlacitek

    if (pageCount <= maxButtonsToShow) {
      // If the total pages are less than or equal to max buttons, show all
      for (let i = 1; i <= pageCount; i++) {
        buttons.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`pagination-btn ${
              i === currentPage ? "active-page" : ""
            }`}
          >
            {i}
          </button>
        );
      }
    } else {
      // Always show first, last, and the current page
      buttons.push(
        <button
          key={1}
          onClick={() => handlePageClick(1)}
          className={`pagination-btn ${1 === currentPage ? "active-page" : ""}`}
        >
          1
        </button>
      );

      if (currentPage > 4) {
        buttons.push(<span key="start-ellipsis">...</span>);
      }

      const startPage = Math.max(currentPage - 2, 2);
      const endPage = Math.min(currentPage + 2, pageCount - 1);

      for (let i = startPage; i <= endPage; i++) {
        buttons.push(
          <button
            key={i}
            onClick={() => handlePageClick(i)}
            className={`pagination-btn ${
              i === currentPage ? "active-page" : ""
            }`}
          >
            {i}
          </button>
        );
      }

      if (currentPage < pageCount - 3) {
        buttons.push(<span key="end-ellipsis">...</span>);
      }

      buttons.push(
        <button
          key={pageCount}
          onClick={() => handlePageClick(pageCount)}
          className={`pagination-btn ${
            pageCount === currentPage ? "active-page" : ""
          }`}
        >
          {pageCount}
        </button>
      );
    }

    return buttons;
  };

  return <div>{renderPageButtons()}</div>;
};

export default Pagination;
